const microGridSteps = [
  {
    description:
      "All solar PV panels connected in the array generate electricity by converting solar radiation into electrical energy.",
  },
  {
    description:
      "The electricity generated from the array of panels is transmitted to a central controller called the Power Conditioning Unit (PCU).",
  },
  {
    description:
      "The PCU controls, regulates and directs the electrical energy transmitted from the array, and supplies electricity directly to homes, shops, offices, street lights etc.",
  },
  {
    description:
      "4.During the day, if the power generated is not used or surplus power is generated, the PCU directs this to the battery bank which stores power. This power can then be used at night (after the sun sets).",
  },
];

const SolarMicroGridTwo = () => {
  return (
    <div className="container-fluid pt-7 pb-7">
      <div className="me-13 ms-13">
        <div className="row">
          <div className="col-12 col-lg-5 pb-5 pb-lg-0">
            <h2 className="fs-56 lh-64 gilroy-bold mb-5">
              SOLAR <span className="text-orange-ryb">MICROGRID</span>
            </h2>
            <p className="fs-16 my-4 lh-30 text-align-justify">
              The microgrid and battery bank are connected to a computer for
              local power usage monitoring. With the addition of a modem, this
              information can be accessed from a remote location, eliminating
              the need for local manpower to monitor the system.
            </p>
            <p className="fs-16 my-4 lh-30 text-align-justify">
              Microgrids can help deploy more zero-emissions energy sources,
              make use of waste heat, reduce energy lost through transmission
              lines, help manage power supply and demand, and improve grid
              resilience to extreme weather.
            </p>
            <p className="fs-16 my-4 lh-30 text-align-justify">
              Microgrids represents a paradigm shift from toward more localized,
              distributed generation—especially in cities, communities &
              campuses. The power to isolate from the larger grid makes
              microgrids resilient, & the ability to conduct flexible, parallel
              operations permits delivery of services that make the grid more
              competitive.
            </p>
          </div>
          <div className="col-12 col-lg-1"></div>
          <div className="col-12 col-lg-6 my-auto">
            {microGridSteps.map((step, index) => (
              <div key={step.description} className="row">
                <div className="col-2 col-md-1 col-lg-2 col-xl-1">
                  <h2
                    className="col-2 text-24 gilroy-bold bg-american-yellow text-center me-4"
                    style={{
                      height: "40px",
                      width: "40px",
                      borderRadius: "50%",
                      lineHeight: "40px",
                    }}
                  >
                    {index + 1}
                  </h2>
                </div>
                <div className="col-10 col-md-11 col-lg-10 col-xl-11">
                  <p className="fs-16">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolarMicroGridTwo;
